import { ClayPaginationWithBasicItems } from "@clayui/pagination";
import ClayTable from "@clayui/table";
import PropTypes from "prop-types";
import React from "react";
import { GOOGLE_MAP_URL } from "../../constant/constant";
import { assets } from "../../styles/css-variables";
import { t } from "i18next";

const ProviderSearchTable = ({
  data,
  isProviderSearch,
  handleSort,
  onPageChange,
  totalPages,
  pageNumber,
}) => {

  const generateGoogleMapsLink = (provider) => {
    const { address, city, state, country } = provider;
    const addressString = `${address},${city},${state},${country}`.replace(
      / /g,
      "+"
    );
    return `${GOOGLE_MAP_URL}?q=${addressString}`;
  };

  return (
    <div className="col-md-9 argusnetwork-table">
      <ClayTable borderless hoverable>
        <ClayTable.Head>
          <ClayTable.Row>
            <ClayTable.Cell onClick={() => handleSort("providerName")}>
              <i className="icon-sort" aria-hidden="true"></i>
              {t("provider-name")}
            </ClayTable.Cell>
            <ClayTable.Cell onClick={() => handleSort("address")}>
              <i className="icon-sort" aria-hidden="true"></i> {t("address")}
            </ClayTable.Cell>
            <ClayTable.Cell onClick={() => handleSort("city")}>
              <i className="icon-sort" aria-hidden="true"></i> {t("city")}
            </ClayTable.Cell>
            <ClayTable.Cell onClick={() => handleSort("state")}>
              <i className="icon-sort" aria-hidden="true"></i> {t("state")}
            </ClayTable.Cell>
            <ClayTable.Cell onClick={() => handleSort("country")}>
              <i className="icon-sort" aria-hidden="true"></i> {t("country")}
            </ClayTable.Cell>
            <ClayTable.Cell onClick={() => handleSort("zip")}>
              <i className="icon-sort" aria-hidden="true"></i> {t("zip-postal")}
            </ClayTable.Cell>
            {isProviderSearch && (
              <ClayTable.Cell onClick={() => handleSort("speciality")}>
                <i className="icon-sort" aria-hidden="true"></i> {t("speciality")}
              </ClayTable.Cell>
            )}
            <ClayTable.Cell className="map">{t("map")}</ClayTable.Cell>
          </ClayTable.Row>
        </ClayTable.Head>

        <ClayTable.Body>
          {data.length > 0 ? (
            data.map((provider, index) => (
              <ClayTable.Row key={`${provider.providerName}_${index}`}>
                <ClayTable.Cell>{provider.providerName}</ClayTable.Cell>
                <ClayTable.Cell>{provider.address}</ClayTable.Cell>
                <ClayTable.Cell>{provider.city}</ClayTable.Cell>
                <ClayTable.Cell>{provider.state}</ClayTable.Cell>
                <ClayTable.Cell>{provider.country}</ClayTable.Cell>
                <ClayTable.Cell>{provider.zip}</ClayTable.Cell>
                {isProviderSearch && (
                  <ClayTable.Cell>{provider.speciality}</ClayTable.Cell>
                )}
                <ClayTable.Cell className="map">
                  <a href={generateGoogleMapsLink(provider)} target="_blank">
                    <i
                      className="icon-external-link orange"
                      aria-hidden="true"
                    ></i>
                  </a>
                </ClayTable.Cell>
              </ClayTable.Row>
            ))
          ) : (
            <ClayTable.Row>
              <ClayTable.Cell colSpan={isProviderSearch ? 8 : 7}>
                <p>{t("no-results")}</p>
              </ClayTable.Cell>
            </ClayTable.Row>
          )}
        </ClayTable.Body>
      </ClayTable>

      {data.length > 0 && (
        <ClayPaginationWithBasicItems
          activePage={pageNumber}
          onPageChange={onPageChange}
          totalPages={totalPages}
          ellipsisBuffer={2}
          spritemap={assets.spriteIcons}
        />
      )}
    </div>
  );
};

ProviderSearchTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  pageNumber: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  isProviderSearch: PropTypes.bool.isRequired,
  handleSort: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default ProviderSearchTable;
